import { FC } from 'react'

import { Grid } from '~ui'
import Filters from '../filters'
import SearchInput from '../search-input'
import { FiltersProps } from '../index'

const DesktopSide: FC<FiltersProps & { placeholder: string; isOpen?: boolean }> = ({
  items,
  placeholder,
  isOpen,
}) => (
  <Grid>
    <SearchInput placeholder={placeholder} />
    <Filters items={items} isOpen={isOpen} />
  </Grid>
)

export default DesktopSide
